import React from 'react';

const BookDetails = ({ book }) => {
  if (!book) return null;

  return (
    <div className="book-info-block">
      {book.cover_image_url && (
        <img 
          src={book.cover_image_url} 
          alt="cover" 
          style={{ 
            width: 120, 
            borderRadius: 8, 
            marginBottom: 12, 
            boxShadow: '0 2px 8px #0001', 
            display: 'block', 
            marginLeft: 'auto', 
            marginRight: 'auto' 
          }} 
        />
      )}
      <h2 style={{ margin: '8px 0 0 0', fontSize: 24, textAlign: 'center' }}>
        {book.title}
      </h2>
      <div style={{ color: '#666', fontSize: 15, margin: '8px 0 0 0', textAlign: 'center' }}>
        {book.description}
      </div>
    </div>
  );
};

export default BookDetails; 